// rrweb/Session Replay's shadow-DOM instrumentation. These names survive
// minification, and nothing of ours defines either one.
const REPLAY_SHADOW_DOM_FRAME_PATTERN = /\b(?:observeAttachShadow|patchAttachShadow)\b/


// Like the stylesheet recursion, this is Replay's own code failing on our origin.
// Its shadow-DOM instrumentation reads `contentWindow.Element` off an iframe it
// has just serialized and then dereferences the `prototype` of whatever comes
// back, without ever checking that the property was there. When it isn't, the
// read throws. There is no message check to go with the frames because the
// wording differs by engine and is generic enough that our own code could raise
// it; the function names are what make the call.
//
// Replay patches the top-level document the same way when it starts, not only
// the iframes it serializes, so the pattern drops an error thrown there too.
// That error is Replay's as well, so the wider match is intentional.
//
export default function isReplayShadowDOMError(frames) {
  return frames.some(({ function: frameFn }) => REPLAY_SHADOW_DOM_FRAME_PATTERN.test(frameFn || ''))
}
